<!--充电机数据 -->
<template>
  <div>
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span class="fontStyle1">{{ $t('QR.deviceSN') }}:{{ basicinfo.chargerSn }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('BondOrUpdateDevice.Model') }}:{{ basicinfo.proModule }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('QR.Dateofmanufacture') }}:{{ basicinfo.makeDateZh }}</span>
      </div>
    </el-row>

    <!-- 列表 -->
    <div id="btUpdateInfo" style="position: relative;">
      <!-- 筛选 -->
      <div class="searchWarp">
        <!-- 日期选择 v-if="activeTab=='btUpdateInfoPane'||activeTab=='chargeHistoryPane'||activeTab=='timeCalibratePane'" -->
        <div class="dataPicker">
          <el-date-picker v-model="selectDay" :end-placeholder="$t('AllDevices.endDate')" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" type="daterange" />
        </div>
        <!-- <el-input v-if="activeTab=='fwPane'" v-model="version" :placeholder="$t('adminView.Version')" class="input-with-select deviceNameTable" clearable>
          <el-button slot="append" icon="el-icon-search" />
        </el-input> -->
      </div>
      <el-tabs v-model="activeTab" style="margin-top:15px;" type="border-card" class="simContentWarp">
        <el-tab-pane :label="$t('dashboard.LatestUpdate')" name="btUpdateInfoPane" style="position:relative;" />
        <el-tab-pane :label="$t('table1.charger_record')" name="chargeHistoryPane" style="position:relative;" />
        <el-tab-pane :label="$t('table1.curve_update_record')" name="curveHistoryPane" style="position:relative;" />
        <el-tab-pane :label="$t('basicinfo.FirmwareVersion')" name="fwPane" style="position:relative;" />
        <el-tab-pane :label="$t('charger.app_operation')" name="event" style="position:relative;" />
        <!-- <el-tab-pane :label="$t('table1.time_calibration')" name="timeCalibratePane" style="position:relative;" /> -->
        <!-- <el-tab-pane :label="$t('charger.schedule_charging')" name="schedule" style="position:relative;" /> -->
        <div v-if="activeTab=='btUpdateInfoPane'">
          <btUpdateInfoTem :active-tab="activeTab" :select-day="selectDay" />
        </div>
        <div v-if="activeTab=='chargeHistoryPane'">
          <btChargeHistoryTem :active-tab="activeTab" :select-day="selectDay" />
        </div>
        <div v-if="activeTab=='curveHistoryPane'">
          <curveHistoryTem :active-tab="activeTab" />
        </div>
        <div v-if="activeTab=='fwPane'">
          <fwTem :active-tab="activeTab" :version="version" />
        </div>
        <event-logs v-if="activeTab=='event'" :selectDay="selectDay"></event-logs>
        <!-- <div v-if="activeTab=='timeCalibratePane'">
          <timeCalibrateTem :active-tab="activeTab" :select-day="selectDay" />
        </div> -->
        <!-- <schedule-table v-if="activeTab=='schedule'" /> -->
      </el-tabs>
    </div>
  </div>

</template>

<script>
import { getModuleValueMap } from '@/api'
// import { chargerPage, pageBluetoothDetail } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table'
// import i18n from '@/i18n'
import btUpdateInfoTem from './btUpdateInfoTem'
import btChargeHistoryTem from './btChargeHistoryTem'
import curveHistoryTem from './curveHistoryTem'
import fwTem from './fwTem'
import timeCalibrateTem from './timeCalibrateTem'
import ScheduleTable from './ScheduleTable.vue'
import EventLogs from './EventLogs.vue'
export default {
  components: {
    btUpdateInfoTem,
    btChargeHistoryTem,
    curveHistoryTem,
    fwTem,
    timeCalibrateTem,
    ScheduleTable,
    EventLogs
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      loading: true,
      selectDay: [],
      version: '',
      tableData: [],
      basicinfo: {
        chargerSn: null,
        proModule: null,
        makeDateZh: null
      },
      activeTab: 'btUpdateInfoPane'
    }
  },
  watch: {
    selectDay(newValue, oldValue) {
      this.selectDay = newValue
    },
    '$i18n.locale'(val) {
      this.getChargeEventI18n()
    }
  },
  created() {
    this.getChargeEventI18n()
  },
  mounted() {
    this.basicinfo.chargerSn = this.$route.query.chargerSn
    this.basicinfo.proModule = this.$route.query.proModule
    this.basicinfo.makeDateZh = this.$route.query.makeDateZh
  },
  methods: {
    getChargeEventI18n() { // 获取充电事件国际化数据
      const language = this.$i18n.locale
      if (this.$i18n.messages[language].chargeEvent) return
      getModuleValueMap(language, {
        'module': 'index',
        'project': 'charger-app'
      }).then(res => {
        console.log(res)
        if (res.resultCode == 1001) {
          this.$i18n.setLocaleMessage(language, Object.assign({ 'chargeEvent': res.resultModel }, this.$i18n.messages[language]))
        }
      })
    }
  }
}
</script>
<style lang="scss">
#btUpdateInfo {
  background: #fff;
  padding: 13px 20px;
  margin-top: 20px;
  .searchWarp {
    margin-bottom: 10px;
  }
  .searchWarp .el-input-group {
    width: 40% !important;
    max-width: 400px !important;
    margin-top: 13px;
  }
  #btUpdateInfoTable .el-button {
    margin: 5px 0;
  }
  .dataPicker {
    display: inline-block;
    margin-bottom: 10px;
    vertical-align: top;
  }
}
</style>
